import { render, staticRenderFns } from "./ContentDelete.vue?vue&type=template&id=11810107&"
import script from "./ContentDelete.vue?vue&type=script&lang=js&"
export * from "./ContentDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports